import { render, staticRenderFns } from "./ResetTwoFactor.vue?vue&type=template&id=1863f416&scoped=true&"
import script from "./ResetTwoFactor.vue?vue&type=script&lang=js&"
export * from "./ResetTwoFactor.vue?vue&type=script&lang=js&"
import style0 from "./ResetTwoFactor.vue?vue&type=style&index=0&id=1863f416&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1863f416",
  null
  
)

export default component.exports